import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <div className="relative h-screen min-h-[600px] flex items-center justify-center">
      {/* Background Image - 使用高品質的宜蘭海岸/太平洋視覺 */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: 'url(https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80)',
        }}
      >
        <div className="absolute inset-0 bg-black/30 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto mt-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="inline-block py-1 px-4 rounded-full bg-orange-500 text-white text-sm font-bold tracking-wider mb-6 shadow-lg">
            歡慶20週年 【鯨夏一跳】特惠中
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 text-shadow-lg leading-tight">
            探索最神秘的蘭陽之星 <br className="hidden md:block"/>
            <span className="text-blue-300">龜山島</span>
          </h1>
          <p className="text-lg md:text-2xl text-slate-100 mb-10 text-shadow max-w-3xl mx-auto font-light">
            觀看全世界最神奇的海底火山「牛奶海」，<br className="hidden md:block"/>
            體驗最專業的賞鯨與生態之旅。
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6">
            <Link 
              to="/packages" 
              className="px-10 py-4 bg-blue-600 hover:bg-blue-500 text-white rounded-full font-bold text-lg transition-all transform hover:scale-105 shadow-xl w-full sm:w-auto"
            >
              查看套裝行程
            </Link>
            <a 
              href="tel:0910071850" 
              className="px-10 py-4 bg-white/10 hover:bg-white/20 text-white border border-white/50 rounded-full font-bold text-lg backdrop-blur-md transition-all w-full sm:w-auto"
            >
              專人電話預約
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div 
        className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/70"
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 1.5 }}
      >
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center p-1">
          <div className="w-1 h-2 bg-white rounded-full"></div>
        </div>
      </motion.div>
    </div>
  );
};

export default HeroSection;